import React from "react";
import { shallowEqual } from "react-redux";
import type { SectionWrapperPropagationProps } from "../../../common/section-wrapper/SectionWrapper";
import SectionWrapper from "../../../common/section-wrapper/SectionWrapper";
import { CarConfigConfigureSectionsLbx } from "../../../../../utils/types/SectionTypesLbx";
import Text from "../../../../../../shared-components/css-modules/lexus/atoms/Text";
import SearchBar from "../../../configure/sections/packs-and-extras/SearchBar";
import Container from "../../../../../../shared-components/css-modules/lexus/atoms/Container";
import Extras from "../../../configure/sections/packs-and-extras/Extras";
import { useCarConfigSelector } from "../../../../../redux/store";
import { extrasSelector } from "../../../../../utils/selectorUtils";
import styles from "./ExtrasWrapper.module.scss";
import SpinContainer from "../../../common/spin/SpinContainer";
import { CarConfigLabel } from "../../../../../utils/labelUtils";
import SliderWrapper from "../../../common/spin/sliderWrapper/SliderWrapper";

const ExtrasWrapper: React.FC<SectionWrapperPropagationProps<CarConfigConfigureSectionsLbx>> = ({
    sectionRefs,
}): JSX.Element => {
    const extras = useCarConfigSelector(extrasSelector, shallowEqual);

    return (
        <SectionWrapper
            sectionId={CarConfigConfigureSectionsLbx.Extras}
            sectionRef={sectionRefs.get(CarConfigConfigureSectionsLbx.Extras)}
        >
            <Container>
                <div className={styles.wrapper}>
                    <div className={styles["slider-wrapper"]}>
                        <figure className={styles.slider}>
                            <SpinContainer settings={{ autoHeight: true, showOnMobile: false, bgColour: "FFFFFF" }} />
                        </figure>
                    </div>
                    <SliderWrapper sticky />
                    <div className={styles.configure}>
                        <header className={styles.header}>
                            <div>
                                <Text tag="h2" variant="apheleia-h4" spacing="spacing-0">
                                    <CarConfigLabel label="carConfigLbxExtrasTitle" />
                                </Text>
                            </div>
                            <SearchBar extrasActive />
                        </header>
                        <div>
                            <Extras extras={extras} />
                        </div>
                    </div>
                </div>
            </Container>
        </SectionWrapper>
    );
};

export default ExtrasWrapper;
